import { FC, Fragment, Suspense } from 'react';

import { LoadingDetailPanel } from '@components/layout/DetailPanel/DetailPanel';
import useMetadataContext from '@hooks/useMetadataContext';
import TitleContextProvider from '@hooks/useTitleContext/provider';
import { robustLazy } from '@utils/robustLazy';

const DetailPanel = robustLazy(() => import('./DetailPanel'));

const DetailPanels: FC = () => {
  const { titlePath } = useMetadataContext();

  return (
    <Fragment>
      <Suspense fallback={<LoadingDetailPanel />}>
        {titlePath.map((titleContext, index) => (
          <TitleContextProvider
            key={`${titleContext.masterId || titleContext.platformTitleId}-${index}`}
            {...titleContext}
          >
            <DetailPanel {...titleContext} />
          </TitleContextProvider>
        ))}
      </Suspense>
    </Fragment>
  );
};

export default DetailPanels;
